import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface TodoFormState {
  isAddFormVisible: boolean
  isEditFormVisible: boolean
  editTodoId: number | null
  editTodoName: string | null
  editTodoDue: Date | null
  editTodoTagIds: number[]
  editTodoUserId: number | null
}

const initialState: TodoFormState = {
  isAddFormVisible: false,
  isEditFormVisible: false,
  editTodoId: null,
  editTodoName: null,
  editTodoDue: null,
  editTodoTagIds: [],
  editTodoUserId: null
}

const todoFormSlice = createSlice({
  name: 'todoForm',
  initialState,
  reducers: {
    showAddForm: (state) => {
      state.isAddFormVisible = true
      // Reset edit state when showing add form
      state.isEditFormVisible = false
      state.editTodoId = null
      state.editTodoName = null
      state.editTodoDue = null
      state.editTodoTagIds = []
      state.editTodoUserId = null
    },
    hideAddForm: (state) => {
      state.isAddFormVisible = false
    },
    showEditForm: (
      state,
      action: PayloadAction<{
        id: number
        name: string
        due: Date
        tagIds?: number[]
        userId?: number
      }>
    ) => {
      state.isEditFormVisible = true
      state.editTodoId = action.payload.id
      state.editTodoName = action.payload.name
      state.editTodoDue = action.payload.due
      state.editTodoTagIds = action.payload.tagIds || []
      state.editTodoUserId = action.payload.userId || null
      // Hide add form when editing
      state.isAddFormVisible = false
    },
    hideEditForm: (state) => {
      state.isEditFormVisible = false
      state.editTodoId = null
      state.editTodoName = null
      state.editTodoDue = null
      state.editTodoTagIds = []
      state.editTodoUserId = null
    }
  }
})

export const { showAddForm, hideAddForm, showEditForm, hideEditForm } =
  todoFormSlice.actions
export default todoFormSlice.reducer
